<template>
  <header class="header" id="home">
    <section class="container">
      <div v-show="showHeader" transition="fade">
        <img class="img" src="/static/img/tempd.png" alt="TEMPd" title="TEMPd">
        <h1 class="title">TEMPd</h1>
        <p class="description">
          Temporary file hosting with immediate automatic deletion when leaving the site.
        </p>
      </div>
      <button id="upload" class="button no-margin-bottom">Drop files or tap to upload</button>
    </section>
  </header>
</template>

<script>

export default {

  props: ['showHeader']

};

</script>

<style scoped>

#upload:focus {
  background-color: #3da5fb;
  border-color: #3da5fb;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.fade-transition {
  transition: all .3s ease;
  height: 300px;
  padding: 10px;
  overflow: hidden;
}

.fade-enter, .fade-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}

</style>



/** WEBPACK FOOTER **
 ** Header.vue?42fc241c
 **/